<template>
    <div class="create-box">
        <div class="card-content animate__animated animate__fadeIn"  v-show="tableData.length>0">
            <course-card v-for="(item,index) in tableData" :key="index" @to_detail="detail(item)" :cardData="item"></course-card>
        </div>
        <no-data style="height: calc(100vh - 43rem);" v-show="tableData.length==0"></no-data>
        <div class="page-box" v-if="tableData.length>0">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pages.current"
                :page-sizes="[8, 16, 32]"
                :page-size="pages.size"
                :pager-count="5"
                :layout="$store.state.media.layout"
                :total="pages.total">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import CourseCard from './common/CourseCard.vue';
import {QueryCourseDetail} from '@/api/course';
import { PageList } from '@/api/course';
import { StudyCourse } from '@/api/study';
    export default {
        components:{ CourseCard },
        props:['classifyCode','name'],
        data(){
            return {
                /**列表数据 */
                tableData:[],
                pages:{
                    size:8,
                    current:1,
                    total:0,
                }
            }
        },
        methods:{
            /**详情 */
            detail(item){
                let params={
                    courseId:item.id,
                    openCourseId:item.openCourseId
                }
                StudyCourse(params).then(res=>{
                    if(res.code==200&&res.data){
                        this.$router.push({
                            path:'/course/studyCourse',
                            query: { id: item.id,openCourseId:item.openCourseId,courseLearningSource:'course_study'}
                        });      
                    }
                })
                // QueryCourseDetail({id:item.id}).then(res=>{
                //     if(res.code==200){
                //         localStorage.setItem('course_study_back',this.$route.fullPath);
                //         localStorage.setItem('base_detail',JSON.stringify(res.data));
                //         this.$router.push({
                //         path:'/course/studyCourse',
                //         query: { id: item.id,openCourseId:item.openCourseId,courseLearningSource:'course_study'}
                //     });      
                //     }
                // })
            },
            search(){
                this.pages.current=1;
                this.queryStudyCourse();
            },
            /**获取我创建的课程 */
            queryStudyCourse(){
                let params={
                    "classifyCode": this.classifyCode,
                    "current": this.pages.current,
                    "courseName": this.name,
                    "queryType":1,
                    "size": this.pages.size,
                    }
                    PageList(params).then(res=>{
                    if(res.code==200){
                        this.tableData=res.data.records;
                        this.pages.total=res.data.total;
                    }
                })
            },
            handleSizeChange(e){
                this.pages.size=e;
                this.pages.current=1;
                this.queryStudyCourse();
            },
            handleCurrentChange(e){
                this.pages.current=e;
                this.queryStudyCourse();
            }
        },
        mounted(){
            this.queryStudyCourse();
        },
        beforeDestroy(){
        }
    }
</script>

<style lang="less" scoped>
.create-box{
    margin-top: 1.5rem;
}
.btn-box{
    width: 16rem;
    height: 4rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #e8ecef;
    border-radius: 10px;
    color: #334681;
    cursor: pointer;
    i{
        color: var(--blue);
        margin-right: 3px;
    }
}
.card-content{
    padding-top: 1rem;
    height: calc(100% - 7rem);
    overflow: auto;
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    column-gap: 2rem;
    row-gap: 4rem;
    &> :nth-child(n){
        width: calc((100% - 6rem)/4) !important;
        min-width: 28rem;
    }
}
/deep/.bottom-title{
    padding: 2rem 0 2.5rem 0;
    border-bottom: 1px solid rgb(247, 247, 249);
}
/deep/.bottom-box{
    padding-top: 0 !important;
}
/deep/.number-num{
    margin-left: 0.8rem;
}
.page-box{
    padding: 3rem 0;
    display: flex;
    justify-content: center;
}
@media screen and (max-width:750px){
    .card-content{
        &> :nth-child(n){
            width: 100% !important;
        }
    }
}
</style>